import { getPath } from '@/router/common'
const baseUrl = {
  title: '车辆跟踪',
  path: 'ztgz'
}

export default [
  {
    path: getPath('index', baseUrl),
    name: 'ztgz_index',
    component: () => import(/* webpackChunkName: "ztgz_index" */ '@/views/ztgz/index/index.vue'),
    meta: {
      title: '车辆跟踪'
    }
  },
  {
    path: getPath('CarGZ', baseUrl),
    name: 'ztgz_CarGZ',
    component: () => import(/* webpackChunkName: "ztgz_CarGZ" */ '@/views/ztgz/carGZ/index.vue'),
    meta: {
      title: '在途跟踪'
    }
  }
]
